import React, { Component } from "react";
import { Tooltip } from "flwww";

const ComponentsToRender1 = (props) => {

  return (
		<div style={{ textAlign: "center", margin: "40px 0" }}>
			<Tooltip text="I'm a default tooltip!">Hover me!</Tooltip>
		</div>
  )
}

const ComponentsToRender2 = (props) => {

  return (
		<div style={{ textAlign: "center", margin: "40px 0" }}>
			<Tooltip
				position="bottom"
				text="I'm a bottom tooltip!">Hover me!</Tooltip>
		</div>
  )
};

const ComponentsToRender3 = (props) => {

	return (
		<div style={{ textAlign: "center", margin: "40px 0" }}>
			<Tooltip
				dark
				text="I'm a dark tooltip!">Hover me!</Tooltip>
		</div>
  )
}


export { ComponentsToRender1, ComponentsToRender2, ComponentsToRender3 };
